// extracted by mini-css-extract-plugin
module.exports = {"cover":"import_cover__3ASLz","fileTip":"import_fileTip__34t10"};